/* eslint-disable camelcase */
import { useState, useEffect } from 'react';
import { withFormik } from 'formik';
import { Container, Col, Form, Row } from 'react-bootstrap';
import { Tabs, Select , Input } from 'components';
import { withStore, useStore } from 'store';
import { CURRENT_GIFT_TABLE } from 'constants/storage64';
import { useStorage64, useGiftTableInfo } from 'hooks';
import { TableHero } from 'components/gifts-table';
import { withAgentPage, withLayout } from 'hocs';
import compose from 'recompose/compose';
import DeleteTableFlux from '../DeleteTableFlux';
import styles from './styles.module.scss';
import { mapPropsToValues } from './config';
import { LIST_OF_SECTIONS, LIST_OF_SECTIONS_WITHOUT_COUPON, OPTIONS_OF_SECTIONS, OPTIONS_OF_SECTIONS_WITHOUT_COUPON } from '../config';

const BaseInfo = ({
  type = { name: '' },
  plan = { name: '' },
  guest_range = {
    minimum: '',
    maximum: '',
  },
  celebrate_labels,
  eventTypes,
}) => {
  const [icon, setIcon] = useState('');
  const [showDeleteTableFlux, setShowDeleteTableFlux] = useState(false);
  const [storageGiftTable] = useStorage64(CURRENT_GIFT_TABLE, {});
  // console.log('storageGiftTable en Base info',storageGiftTable);
  useEffect(() => {
 
  }, [storageGiftTable])
  
  const handleClickDeleteHero = () => {
    setShowDeleteTableFlux(true);
  };

  const handleClose = () => {
    setShowDeleteTableFlux(false);
  };

  const [tableInfo, dispatch] = useStore(
    (state) => state.giftTable.giftTableInfo.data
  );

  const disabledClose = (date) => {
    if (date.length) {
      const formatedDate = date;
      const datePresent = new Date().setHours(0,0,0,0);
      const dateEvent = new Date(formatedDate).setHours(0,0,0,0);
      return dateEvent >= datePresent;
    }
    return true;
  }

  const isValidCoupon = +tableInfo?.id <= 1665 ? false : tableInfo?.coupon ? true : !!tableInfo?.applyBonification;
  const showDocumentation = tableInfo.upload_files_closing
  const eventIsInFuture = disabledClose(tableInfo.date || '');

  useEffect(() => {
    if (eventTypes) {
      const eventTypeIcon = eventTypes.find(
        (eventType) => eventType.id === type.id
      );

      setIcon((currentIcon) =>
        eventTypeIcon ? eventTypeIcon.image : currentIcon
      );
    }
  }, [eventTypes, type]);

  useEffect(() => {
    if (guest_range) {
      // console.log('range',guest_range);
    }
  }, [guest_range]);


  return (
    <>
    <DeleteTableFlux show={showDeleteTableFlux} onClose={handleClose} />
    <section className={styles.TableAdmin}>
      <TableHero
        image={storageGiftTable?.image}
        typeId={tableInfo?.type?.id}
        eventName={tableInfo?.type?.name}
        name={tableInfo?.name}
        date={tableInfo?.date}
        readOnly={false}
        onDeleteHero={handleClickDeleteHero}
      />

      <Container className="mb-5">

        <Tabs
            id="my_table_tabs"
            listOfSections={isValidCoupon ? LIST_OF_SECTIONS : LIST_OF_SECTIONS_WITHOUT_COUPON}
            showDocumentation={showDocumentation}
            eventIsInFuture={eventIsInFuture}
            className={`${styles.tabContent} py-4 px-3`}
            defaultSection="general_data"
            customActiveSection="general_data"
            
          />
            
      

      </Container>
    </section>
    </>
  );
};

export default compose(
  withLayout,
  withAgentPage(),
  withFormik({ mapPropsToValues }),
  withStore({
    mapStateToProps: (state) => ({
      ...state.giftTable.giftTableInfo.data,
      eventTypes: state.catalogs.fullEventTypes || [],
    }),
  })
)
(BaseInfo);
